// Copyright (c) Docugami, Inc. All rights reserved.

import { NavigationListItem } from "components/myContentExplorer/NavigationItemList";
import { dgIconNames } from "hooks/dgIcons";
import { ExplorerViewType, NavigationGroup, ReviewDocsId } from "../components/myContentExplorer/ExplorerTypes";
import { IExplorerNavigationGroup } from "./ExplorerNavigationGroups";
import { useMemo } from "react";
import { useNavigationService, NavigationType } from "./navigationService";
import { AutomationId } from "utils/Automation";

export function useReviewDocsNavigationGroup(): IExplorerNavigationGroup {
    const navService = useNavigationService();

    const items = useMemo((): NavigationListItem[] => {
        return [
            {
                id: ReviewDocsId.Unassigned,
                title: `${ReviewDocsId.Unassigned} Docs`,
                type: ExplorerViewType.Unassigned,
                icon: getIconForReviewDoc(ReviewDocsId.Unassigned),
                onClick: () => navService.navToUnassignedFiles(NavigationType.PushNewPage),
                automationId: AutomationId.DocExplorerUnassignedDocs
            },
            {
                id: ReviewDocsId.Error,
                title: `${ReviewDocsId.Error} Docs`,
                type: ExplorerViewType.Unassigned,
                icon: getIconForReviewDoc(ReviewDocsId.Error),
                onClick: () => navService.navToErrorFiles(NavigationType.PushNewPage),
                automationId: AutomationId.DocExplorerErrorDocs
            },
        ]
    }, [navService]);

    return {
        id: NavigationGroup.ReviewDocs,
        title: "Docs to Review",
        items: items,
        statusItems: []
    }
}

function getIconForReviewDoc(id: string) {
    switch (id) {
        case ReviewDocsId.Error:
            return {
                name: dgIconNames.DgErrorDocs,
                height: 13,
                width: 10
            }
        case ReviewDocsId.Unassigned:
            return {
                name: dgIconNames.DgUnassignedDocs,
                height: 13,
                width: 10
            }
    }
}
